export const defaultFlags = {
  education: false,
  'workspace-members-filter': false,
  'report-subscriptions-to-sentry': false,
  'cwv-custom-grid': false,
  'restricted-uploads': false,
  'components-description': false,
  profiles: false,
  'community-canvas': false,
  'publish-community': false,
  'dark-mode-toggle': false,
  'byok-access': false,
  'frontend-consolidate': false,
  'workspace-integrations': false,
  'slack-mention-notifications': false,
  'canvas-focus-animation': false,
  'canvas-version-compare': false,
  // these flags are used when user is not even signed in
  // it is expected that these flags will be changed
  // using DevTools
  'publication-hearts': false,
  'multiple-selection': false,
  'show-pending-memberships': false,
  'better-notifications': false,
  'recently-opened-shares': false,
  'audit-log': false,
} as const
